import { PoolInfo } from './usePoolInfo'
import { useEffect, useState } from 'react'
import { useNow } from './useCountDown'
import useDrawStatus, { DrawStatus } from './useDrawStatus'

export enum IGOStage {
  None,
  OnSale,
  ReBase,
  Draw,
  Finish,
  DrawIn,
  DrawOut,
}

export default function useIGOStage(poolInfo: PoolInfo | null) {
  const { now, stop } = useNow()
  const [stage, setStage] = useState<IGOStage>(IGOStage.None)
  const drawStatus = useDrawStatus(poolInfo?.address)

  useEffect(() => {
    if (poolInfo) {
      if (poolInfo.raisedStartTime >= now) {
        setStage(IGOStage.None)
        return
      }
      if (poolInfo.raisedEndTime >= now) {
        setStage(IGOStage.OnSale)
        return
      }
      stop()
      if (!poolInfo.hasRebase) {
        setStage(IGOStage.ReBase)
        return
      }
      if (drawStatus === DrawStatus.NotDraw) {
        setStage(IGOStage.Draw)
        return
      }
      if (drawStatus === DrawStatus.DrawIn) {
        setStage(IGOStage.DrawIn)
        return
      }
      if (drawStatus === DrawStatus.DrawOut) {
        setStage(IGOStage.DrawOut)
        return
      }
    }
  }, [poolInfo, now, drawStatus, stop])
  return stage
}
